/* eslint-disable no-alert */
/* eslint-disable no-unused-vars */
/* eslint-disable no-dupe-keys */
/* eslint-disable jsx-a11y/control-has-associated-label */
import React, { } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';

import Home1 from './pages/home1';
import NewHome from './components/NewHome';
import Contact from './components/Contact';
import Support from './components/Support';
import About from './components/About';
import Removal from './components/Removal';
import Solutions from './components/Solutions';
import HTMLFiles from './components/HTMLFiles';
import NotFound from './pages/NotFound';
import ZackatImage from './components/ZackatImage';

import './App.css';

const App = () => (
  <div>
    <BrowserRouter
      future={{
        v7_startTransition: true,
        v7_relativeSplatPath: true,
      }}
    >
      <div className="center-container">
        <Routes>
          <Route path="*" element={<NotFound />} />
          <Route path="/" element={<Home1 />} />
          <Route path="/about" element={<About />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/support" element={<Support />} />
          <Route path="/removal" element={<Removal />} />
          <Route path="/solutions" element={<Solutions />} />
          <Route path="/newhome" element={<NewHome />} />
          {/* pages  */}
          <Route path="/hipaa" element={<HTMLFiles props={{ mdfile: 'hipaa.md' }} />} />
          <Route path="/privacy" element={<HTMLFiles props={{ mdfile: 'privacy.md' }} />} />
          <Route path="/tos" element={<HTMLFiles props={{ mdfile: 'tos.md' }} />} />
          <Route path="/sample" element={<ZackatImage dt={{ image: 'sample.png' }} />} />
          <Route path="/sample2" element={<ZackatImage dt={{ image: 'sample2.png' }} />} />
        </Routes>
      </div>
    </BrowserRouter>
  </div>
);

export default App;
